import { cloneDeep } from 'lodash';

export default {
  data() {
    return {
      
    }
  },

  methods: {
    // 处理搜索
    handleSearch (searchData) {
      if (searchData.cabinetNo) {
        this.searchValue = searchData.cabinetNo;
      }
      if (searchData && searchData.cidrAddr) {
        this.search = searchData.cidrAddr;
      }
      if (searchData) {
        this.searchForm = cloneDeep(searchData);
      }
      this.initFlag = true;
      this.currentPage = 1;
      this.updateList('refresh', true);
    },
    // 处理重置
    handleReset () {
      // 使用for...in循环清空searchForm数据
      for (const key in this.searchForm) {
        if (Array.isArray(this.searchForm[key])) {
          // 处理数组类型参数（多选下拉框）
          this.searchForm[key] = [];
        } else if (typeof this.searchForm[key] === 'string') {
          // 处理字符串类型参数（输入框）
          this.searchForm[key] = '';
        }
      }
      if (this.searchValue) {
        this.searchValue = '';
      }
      this.search = '';
      this.currentPage = 1;
      // 清空标签搜索
      if (this.filteredResourceIds && this.filteredResourceIds.length) {
        this.filteredResourceIds = [];
      }
      this.updateList('refresh', true);
    },
  },
}


// WEBPACK FOOTER //
// ./src/mixins/searchOperate.js